module.exports = "https://img1.huilianyi.com/8/cover-en.81cbdd08b1.appcore.png";